import React, { useRef } from 'react';

import { uniqueId } from 'filestack-js';

import Icon from 'components/shared/Icon/Icon';
import Loader from 'components/shared/Loader/Loader';

import DragAndDropFiles from './DragAndDropFiles';

const SendFaxFiles = ({ setDocsModalVisible, formik, error, setError, docsLoading }) => {
  const fileInputRef = useRef(null);

  const { setFieldValue, values } = formik;

  const handleDivClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    let filesArray = Array.from(e.target.files);
    filesArray = filesArray.map((file) => {
      file['id'] = file.size;
      file['draggableId'] = uniqueId(12);
      return file;
    });
    setFieldValue('files', [...values.files, ...filesArray]);
    setError((prev) => ({ ...prev, file: null }));
    e.target.value = null;
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    let droppedFiles = e.dataTransfer.files;
    droppedFiles = Array.from(droppedFiles).map((file) => {
      file['id'] = file.size;
      file['draggableId'] = uniqueId(12);
      return file;
    });
    setFieldValue('files', [...values.files, ...droppedFiles]);
    setError((prev) => ({ ...prev, file: null }));
  };

  return (
    <div className=" flex-1 gap-2 bg-white !p-6">
      <div className="flex items-center justify-between">
        <label className=" pb-1" htmlFor="">
          Attachments <span className="inline text-red-600">*</span>
        </label>
        {docsLoading ? (
          <></>
        ) : (
          <label
            htmlFor=""
            className="flex cursor-pointer"
            onClick={() => setDocsModalVisible(true)}>
            Search from existing documents
            <Icon
              icon="new-attach-square"
              className="!ml-1 inline cursor-pointer"
              data-qa="search-from-existing-documents"
            />
          </label>
        )}
      </div>
      <input
        type="file"
        onChange={handleFileChange}
        ref={fileInputRef}
        data-qa="input-file"
        style={{ display: 'none' }}
        accept="image/*,.pdf,.txt"
        multiple
      />
      <div
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onClick={handleDivClick}
        data-qa="upload-attachment"
        className="flex h-[176px]  cursor-pointer flex-col items-center justify-center rounded-lg border-[1px] border-dashed border-primary-400 bg-gradient-to-r from-primary-50 to-primary-100">
        <div className="flex flex-col items-center justify-center">
          <Icon icon="file-upload-mono" className="cursor-pointer rounded-full bg-white" />
          <p className="pt-1 text-center text-sm font-400 text-neutral-500">
            Click here or drag and <span>drop files to upload</span>
          </p>
        </div>
      </div>

      {error.file && <p className="!pt-2 text-sm text-danger-500">{error.file}</p>}
      {docsLoading ? (
        <div className="flex items-center justify-center p-4">
          <Loader
            outlined
            color="primary"
            shade="500"
            className="mr-2 !size-[14px] h-[14px] !min-h-[14px] w-[14px] !min-w-[14px]"
          />
          <label htmlFor="" className="flex">
            Inserting documents...
          </label>
        </div>
      ) : (
        <div className="!mt-4">
          <DragAndDropFiles {...{ selectedFiles: values.files, setFieldValue }} />
        </div>
      )}
    </div>
  );
};

export default SendFaxFiles;
